import React from "react";
import { Outlet } from "react-router-dom";
import Notify from "./Components/Notify/Notify";
import { LibraryProvider } from "./context/LibraryContext";
import AdminHeader from "./Components/Admin/Header/AdminHeader";
import PushNotification from "./PushNotification";
import FloatingActionButton from "./Components/CommonComponents/FloatingActionButton";
import Headers from "./Components/Student/Header/Header";
import Header from "./Components/CommonComponents/Header";
import { getDataFromStorage } from "./util";
import constants from "./constants";
import { useContext } from "react";
import AlertContext from "./context/AlertContext";

const MainLayout = () => {
    const pathname = window.location.pathname; // Assuming pathname is used here
  const isAuthenticated = () => !!localStorage.getItem("tokenKey");
  const isAdmin = getDataFromStorage("role") !== "learner";
  const {isFullScreen,notificationPayload} = useContext(AlertContext); // Replace with actual logic
//   const notificationPayload = { open: false }; // Replace with actual logic
  const showFloatingActionBtn = false; // Replace with actual logic
const isPreview =
    new URLSearchParams(window.location.search).get("mode") === "preview";
  const isPreviewLp =
    new URLSearchParams(window.location.search).get("mode") === "previewlp";

    return (<>
        <Notify />
        {/* {isLoaded && <Loading />} */}
        {([constants.Roles.learner, constants.Roles.parent].includes(getDataFromStorage("role")) ||
            (([constants.Roles.admin, constants.Roles.trainer, constants.Roles.super_admin, constants.Roles.evaluator]
                .includes(getDataFromStorage("role"))) && pathname === "/sandpack")) &&
            pathname !== "/home" &&
            !pathname.includes("/dp") &&
            !pathname.includes("main") &&
            isAuthenticated()  &&
            (pathname === "/sandpack"  ? (
                <Headers />
            ) : (
                !isFullScreen && !isPreviewLp && <Header />
            ))}

        {notificationPayload.open && <PushNotification />}

        {pathname !== "/sql" &&
            pathname !== "/mcq" &&
            pathname !== "/coding" &&
            pathname !== "/company" &&
            pathname !== "/sandpack" &&
            pathname !== "/assignment" &&
            pathname !== "/ainterview" &&
            !isPreview &&
            !isPreviewLp &&
            isAuthenticated() &&
            [constants.Roles.hr, constants.Roles.admin, constants.Roles.tutor, constants.Roles.evaluator,
            constants.Roles.trainer, constants.Roles.customer, constants.Roles.super_admin,
            constants.Roles.creator].includes(getDataFromStorage("role")) ? (
            <LibraryProvider>
                <AdminHeader />
            </LibraryProvider>
        ) : (
            isAdmin &&
            getDataFromStorage("role") !== constants.Roles.parent &&
            ["/mcq", "/sql", "/coding", "/company", "/assignment"].includes(pathname) && <Header />
        )}

        {showFloatingActionBtn && !isAdmin && <FloatingActionButton />}


        <Outlet />
    </>
    )
}

export default MainLayout;